/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlanTimelineConfigProviderEntryEntrypointProps } from './PlanTimelineConfigProviderEntry.entrypoint.types.tsx';

type PlanTimelineConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	PlanTimelineConfigProviderEntryEntrypointProps,
	{} | null
>;

export const planTimelineConfigProviderEntrypoint: EntryPoint<
	PlanTimelineConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<PlanTimelineConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-plan-timeline-config-provider" */ './PlanTimelineConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
